import { type ReactNode } from 'react';

import {
  type ProjectExternalStatus,
  type ProjectStatus,
} from 'interfaces/projects/ProjectData.interface';
import { colors } from 'lib/colors';
import OngoingProjectIcon from 'components/icons/OngoingProjectIcon/OngoingProjectIcon';
import Tippy from '@tippyjs/react';

export const getProjectStatus = (status: ProjectStatus): ReactNode => {
  switch (status) {
    case 'NEW':
      return 'New';
    case 'TRAINING':
      return 'Training';
    case 'TRAINED':
      return 'Trained';
    case 'APPLYING':
      return 'Applying';
    case 'APPLIED':
      return 'Applied';
    case 'ONGOING':
      return 'Ongoing';
    case 'MISSING_DATA':
      return 'Missing Data';
    case 'FINISHED':
      return 'Finished';
    default:
      return status;
  }
};

export const getProjectStatusTooltip = (status: ProjectStatus): ReactNode => {
  const statusConfig = {
    MISSING_DATA: {
      icon: <OngoingProjectIcon />,
      tooltip:
        'Data could not get fetched for this meter for the selected Reference Period.',
    },
    // TRAINING: {
    //   icon: <MissingDataIcon />,
    //   tooltip: 'Project in calculation. Please check back later.',
    // },
    // TRAINED: {
    //   icon: <MissingDataIcon />,
    //   tooltip: 'Project in calculation. Please check back later.',
    // },
    // APPLYING: {
    //   icon: <MissingDataIcon />,
    //   tooltip: 'Project in calculation. Please check back later.',
    // },
    // APPLIED: {
    //   icon: <MissingDataIcon />,
    //   tooltip: 'Project in calculation. Please check back later.',
    // },
  };

  const config = statusConfig[status as keyof typeof statusConfig];

  if (!config) return null;

  return (
    <span className="ml-1">
      <Tippy content={config.tooltip}>
        <span className="cursor-help">{config.icon}</span>
      </Tippy>
    </span>
  );
};

export const getProjectExternalStatus = (
  status: ProjectExternalStatus
): ReactNode => {
  const statusConfig: Record<
    ProjectExternalStatus,
    {
      label: string;
      dotColor: string;
      textColor: string;
    }
  > = {
    SUGGESTED: {
      label: 'SUGGESTED',
      dotColor: colors.status.new,
      textColor: 'text-gray-700',
    },
    PLANNED: {
      label: 'PLANNED',
      dotColor: colors.alert,
      textColor: 'text-gray-700',
    },
    IMPLEMENTED: {
      label: 'IMPLEMENTED',
      dotColor: colors.status.solved,
      textColor: 'text-gray-700',
    },
  };

  const config = statusConfig[status];

  // Handle case where status is not in our config (fallback)
  if (!config) {
    return (
      <div className="flex items-center gap-2">
        <span
          className="w-2 h-2 rounded-full"
          style={{ backgroundColor: colors.status.new }}
        ></span>
        <span className="text-sm font-medium text-gray-700">{status}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span
        className="w-2 h-2 rounded-full"
        style={{ backgroundColor: config.dotColor }}
      ></span>
      <span className={`text-sm font-medium ${config.textColor}`}>
        {config.label}
      </span>
    </div>
  );
};
